import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Button } from '../../../../components/Button';

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid ${colorsPalettes.carbon[100]};
  flex-shrink: 0;
`;

export const StyledHeaderTitle = styled.div`
  ${setFontVariant('primaryItem', colorsPalettes.carbon[500])};
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const StyledCloseButton = styled(Button)`
  width: 28px;
  height: 28px;
  padding: 0;
  background: transparent;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;

  svg {
    width: 8px;
    height: 8px;
  }

  &:hover,
  &:active {
    background: ${colorsPalettes.bluegrey[100]};
  }
`;
